import { EventsResponseModel } from '@swagger-sse/api';

import { LightState } from '@tools/enums';
import { LiveDataEvent, LiveDataAction } from '@store/types';
import { LiveDataActionTypes, SmartHomeDevice } from '@store/enums';

export class SmartLightEvent implements LiveDataEvent {
    private eventData: EventsResponseModel;

    constructor(data: EventsResponseModel) {
        this.eventData = data;
    }

    public getAction(): LiveDataAction {
        const smartLightsData = this.eventData.data;

        if (!smartLightsData) {
            return {
                type: LiveDataActionTypes.SMART_LIGHTS_EVENT,
                payload: null,
            };
        }

        const deviceId = this.eventData.deviceId;

        if (typeof smartLightsData.switch !== 'undefined') {
            const state: LightState =
                smartLightsData.switch === 1 ? LightState.ON : LightState.OFF;

            return {
                type: LiveDataActionTypes.SMART_LIGHTS_EVENT,
                payload: {
                    deviceId,
                    deviceType: SmartHomeDevice.SMART_LIGHT,
                    state,
                    loaded: true,
                },
            };
        }

        if (typeof smartLightsData.dimLevel !== 'undefined') {
            const dimLevel = smartLightsData.dimLevel;

            return {
                type: LiveDataActionTypes.SMART_LIGHTS_EVENT,
                payload: {
                    deviceId,
                    deviceType: SmartHomeDevice.SMART_LIGHT,
                    dimLevel,
                    loaded: true,
                },
            };
        }

        return {
            type: LiveDataActionTypes.SMART_LIGHTS_EVENT,
            payload: null,
        };
    }
}
